module.exports = __webpack_public_path__ + "static/img/expired.434cc28d.png";